import React from "react";
import {
  Col,
  Card,
  CardBody,
  CardTitle,
  ListGroup,
  ListGroupItem,
  Modal,
  ModalHeader,
  UncontrolledTooltip,
  ModalBody,
  Table,
} from "reactstrap";
import interests from "helpers/Interests";
import { useTranslation } from "react-i18next";
import { LazyImage, RenderButton } from "../../../components";
import { showTitle, showTooltip } from "../../../actions";
const InfluencerInterests = (props) => {
  const { t } = useTranslation();

  return (
    <Col sm="6">
      <Card className="card-content-custom">
        <CardBody>
          <CardTitle>{t("reports.influencer_details.interests")}</CardTitle>
          <ListGroup className="ba-list ch-6">
            {props.accountOverviewDetails &&
            props.accountOverviewDetails.user_profile &&
            props.accountOverviewDetails.user_profile.interests ? (
              props.accountOverviewDetails.user_profile.interests.map(
                (interest, index) => {
                  if (index < 5) {
                    return (
                      <ListGroupItem
                        key={index}
                        className="d-flex align-items-center"
                      >
                        <div className="mr-3">
                          <LazyImage
                            src={props.generateImgUrl("interest", interest.id)}
                            alt="img"
                          />
                        </div>
                        <div className="text-wrap">
                          {
                            interests.find(
                              (option) => option.value === interest.id
                            ).label
                          }
                        </div>
                      </ListGroupItem>
                    );
                  }
                  return null;
                }
              )
            ) : (
              <span className="text-center text-grey ">
                <p className="pt-50">{t("errors.no_record")}</p>
              </span>
            )}
          </ListGroup>
          {props.accountOverviewDetails &&
          props.accountOverviewDetails.user_profile &&
          props.accountOverviewDetails.user_profile.interests ? (
            <div className="bottom">
              <RenderButton
                color="link"
                onClick={() => props.toggleModal("influencersInterestsModal")}
              >
                {t("reports.view_more")}
              </RenderButton>
              <Modal
                id="influencersInterestsModalDownload"
                isOpen={props.modals.influencersInterestsModal}
                toggle={() => props.toggleModal("influencersInterestsModal")}
              >
                <ModalHeader
                  toggle={() => props.toggleModal("influencersInterestsModal")}
                >
                  <span className="tooltip-button-wrap">
                    <span className="text-tooltip">
                      {t("reports.influencer_details.interests")}
                    </span>
                    <span
                      href="#"
                      id="influencersInterestsModal"
                      className="tooltip-icon"
                    ></span>
                  </span>
                  {props.tooltip && (
                    <UncontrolledTooltip
                      placement="bottom"
                      className="tooltip-content"
                      target="influencersInterestsModal"
                    >
                      {showTooltip("influencersInterestsModal")}
                    </UncontrolledTooltip>
                  )}
                  <RenderButton
                    onClick={() =>
                      props.downloadPdf("influencersInterestsModalDownload")
                    }
                    className="download-icon-button mg-left-15 link"
                  >
                    {t("reports.download")}
                  </RenderButton>
                </ModalHeader>
                <ModalBody>
                  <Table className="modal-table">
                    <thead>
                      <tr>
                        <th colSpan={2}>{t("reports.chart.interest")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.accountOverviewDetails &&
                      props.accountOverviewDetails.user_profile &&
                      props.accountOverviewDetails.user_profile.interests ? (
                        props.accountOverviewDetails.user_profile.interests.map(
                          (interest, index) => (
                            <tr key={index}>
                              <th colSpan={2} scope="row">
                                <div className="country-text-wrap">
                                  <div className="flag-img brand-img icon">
                                    <img
                                      src={props.generateImgUrl(
                                        "interest",
                                        interest.id
                                      )}
                                      alt="img"
                                    />
                                  </div>
                                  <div
                                    id={`influencer_${interest.name}`}
                                    title={showTitle(
                                      `influencer_${interest.name}`,
                                      interest.name
                                    )}
                                    className="interest-name"
                                  >
                                    {
                                      interests.find(
                                        (option) => option.value === interest.id
                                      ).label
                                    }
                                  </div>
                                </div>
                              </th>
                            </tr>
                          )
                        )
                      ) : (
                        <tr>
                          <td align="center" colSpan="2">
                            {t("errors.no_record")}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </ModalBody>
              </Modal>
            </div>
          ) : null}
        </CardBody>
      </Card>
    </Col>
  );
};

export default InfluencerInterests;
